import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: true,
  results: [],
  hasJobsInProcess: false,
  hasFetched: false,
  hasProcessed: false,
  processed: [],
  jobsList: {
    metaData: {},
    jobs: [],
  },
  selectedStandardTemplate: {},
  error: null,
  aggregates: null,
  ecslTotals: null,
  manualAdjustments: {
    isLoading: false,
    response: null,
  },
};
export default reducerFactory(initialState, {
  [types.RESET_STANDARD_TEMPLATE]: () => initialState,
  [types.UPLOAD_STANDARD_TEMPLATE_REQUEST]: state => ({
    ...state,
    isLoading: true,
    hasFetched: false,
    error: null,
    results: [],
  }),
  [types.UPLOAD_STANDARD_TEMPLATE_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasFetched: true,
    ...response.standardTemplate,
  }),
  [types.UPLOAD_STANDARD_TEMPLATE_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasFetched: true,
    error: response.error,
  }),
  [types.GET_STANDARD_TEMPLATES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    hasFetched: false,
    error: null,
  }),
  [types.GET_STANDARD_TEMPLATES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasFetched: true,
    ...response.standardTemplates,
    selectedStandardTemplate:
      response.standardTemplates.results.length > 0 && response.standardTemplates.results[0],
  }),
  [types.GET_STANDARD_TEMPLATES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasFetched: true,
    error: response.error,
  }),
  [types.PROCESS_STANDARD_TEMPLATES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    hasProcessed: false,
    error: null,
  }),
  [types.PROCESS_STANDARD_TEMPLATES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasProcessed: true,
    processed: response.standardTemplates,
  }),
  [types.PROCESS_STANDARD_TEMPLATES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasProcessed: true,
    error: response.error,
  }),
  [types.CREATE_STANDARD_TEMPLATE_REQUEST]: state => ({
    ...state,
    isLoading: true,
    hasProcessed: false,
    error: null,
  }),
  [types.CREATE_STANDARD_TEMPLATE_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasProcessed: true,
    results: [...state.results, response.standardTemplate],
  }),
  [types.CREATE_STANDARD_TEMPLATE_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasProcessed: true,
    error: response.error,
  }),
  [types.GET_STANDARD_TEMPLATE_JOBS_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.GET_STANDARD_TEMPLATE_JOBS_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    hasJobsInProcess: response.jobsData.jobs.length > 0,
    jobsList: response.jobsData,
  }),
  [types.GET_STANDARD_TEMPLATE_JOBS_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.GET_STANDARD_TEMPLATE_AGGREGATES_REQUEST]: state => ({
    ...state,
    isLoading: true,
    error: null,
  }),
  [types.GET_STANDARD_TEMPLATE_AGGREGATES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    aggregates: response,
  }),
  [types.GET_STANDARD_TEMPLATE_AGGREGATES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.GET_STANDARD_TEMPLATE_ECSL_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.GET_STANDARD_TEMPLATE_ECSL_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    ecslTotals: response,
  }),
  [types.GET_STANDARD_TEMPLATE_ECSL_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
  [types.SAVE_MANUAL_ADJUSTMENTS]: state => ({
    ...state,
    manualAdjustments: { isLoading: true },
    error: null,
  }),
  [types.SAVE_MANUAL_ADJUSTMENTS_SUCCESS]: (state, { response }) => ({
    ...state,
    manualAdjustments: {
      isLoading: false,
      response,
    },
  }),
  [types.SAVE_MANUAL_ADJUSTMENTS_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    manualAdjustments: {
      isLoading: false,
      error: response.error,
    },
  }),
  [types.GET_PREVIOUS_FILING_DATA_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [types.GET_PREVIOUS_FILING_DATA_SUCCESS]: state => ({
    ...state,
    isLoading: false,
  }),
  [types.GET_PREVIOUS_FILING_DATA_FAILURE]: state => ({
    ...state,
    isLoading: false,
  }),
  [types.FETCH_PROCESSING_AGGREGATES_SUCCESS]: (
    state,
    { payload: { aggregates, isDataProcessingAggregate } }
  ) => ({
    ...state,
    aggregates,
    selectedStandardTemplate: {
      ...state.selectedStandardTemplate,
      isDataProcessingAggregate,
    },
  }),
});
